const addToCartForms = document.querySelectorAll('form[action="/cart/add"][data-dispatch-type="custom-card"]');

addToCartForms.forEach((form) => {
    var dispatch_loc = form.getAttribute('data-dispatch-loc'); // decides whether to open the cart drawer or not
    form.addEventListener('submit', async (e) => {
        e.preventDefault();

        const addButton = form.querySelector('span[data-button-name="add"]');
        const loadingButton = form.querySelector('span[data-button-name="loading"]');
        addButton.classList.add('hidden');
        loadingButton.classList.remove('hidden');
        addButton.classList.remove('flex');
        loadingButton.classList.add('flex');

        try {
            // Submit the data to cart.js
            const cartAddResponse = await fetch('/cart/add', {
                method: 'POST',
                body: new FormData(form),
            });

            if (!cartAddResponse.ok) {
                throw new Error('Failed to add to cart');
            }

            // Update cart count 
            const cartRes = await fetch('/cart.js');
            const cartData = await cartRes.json();

            // Update cart count elements
            document.querySelectorAll('.cart-count').forEach((el) => {
                el.textContent = cartData.item_count;
            });

            // Dispatch events
            window.dispatchEvent(new CustomEvent('custom-update-cart'));
            // Check if the form is "quick-access"
            // if (dispatch_loc === 'quick-access') {
            //     // Only open the drawer on mobile (less than 768px width)
            //     if (window.innerWidth < 768) {
            //         window.dispatchEvent(new CustomEvent('open-cart-drawer'));
            //     }
            // } else {
            //     // Open the drawer on both mobile and desktop
            //     window.dispatchEvent(new CustomEvent('open-cart-drawer'));
            // }

            window.dispatchEvent(new CustomEvent('open-cart-drawer'));


        } catch (error) {
            console.error('Error adding to cart:', error);
        } finally {
            // Reset the loading state
            addButton.classList.remove('hidden');
            loadingButton.classList.add('hidden');
            addButton.classList.add('flex');
            loadingButton.classList.remove('flex');
        }
    });
});